import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppSettingsService } from '../config/config-service';
import { CommonService } from './common.service';

@Injectable({ providedIn: 'root' })
export class WalletService {
  private apiUrl: string;

  // ⚠️ If your user-investments route differs, update USER_INVESTMENTS_PATH below.
  private readonly USER_INVESTMENTS_PATH = '/api/userInvestments/availableByPortfolio';

  constructor(
    private http: CommonService,   
    private appSettingsService: AppSettingsService,
  ) {
   this.apiUrl =  this.appSettingsService.getSettings().apiEndPoint || ''
  }

  // POST { userId } — your backend expects userId in body
  getWalletBalance(userId: string): Observable<{
    balance: number; roiAvailable: number; currency: string;
    isLocked: boolean; totalDeposits: number; totalWithdrawals: number;
  }> {
    return this.http.post<any>(`${this.apiUrl}/api/wallets/balance`, { userId }).pipe(
      map(res => res?.data),
      catchError(err => throwError(() => new Error(err?.error?.error || 'Unable to fetch wallet balance')))
    );
  }

  // Per-portfolio ROI (we rely on your enriched getAllUserInvestments)
  // It should return items with: portfolioId{ name, ... }, roiAvailableFromThisPortfolio, roiEarnedLifetime
  getInvestmentsForRoi(userId: string): Observable<any[]> {
    return this.http.get<any>(`${this.apiUrl}${this.USER_INVESTMENTS_PATH}?userId=${encodeURIComponent(userId)}`).pipe(
      
      catchError(err => throwError(() => new Error(err?.error?.error || 'Unable to fetch portfolio ROI')))
    );
  }

  // Wallet transactions list (uses auth on server to resolve user)
  listRecentWalletTransactions(limit = 5, type = ''): Observable<any[]> {
    const q = new URLSearchParams();
    q.set('limit', String(limit));
    if (type) q.set('transactionType', type);
    return this.http.get<any>(`${this.apiUrl}/api/walletTransactions/getAllWalletTransactions?${q.toString()}`).pipe(
      map(res => Array.isArray(res?.data) ? res.data : []),
      catchError(err => throwError(() => new Error(err?.error?.error || 'Unable to fetch wallet activity')))
    );
  }
}
